import cacheableRequest from '../../../services/cacheableRequest';
import { AxiosError, AxiosResponse } from 'axios';
import { CourseStep } from '../models/course';

type Report = {
  id: string;
  visibility: string;
};

type GetCourseResponse = {
  tasklist: {
    _id: {
      id: string;
    };
    name: string;
    description: string;
    posterImage?: string;
    owner: string;
    reportToGenerate?: string;
    lastModifiedDate: string;
    published: boolean;
    suggestedTimeFrameDays?: number;
    certificateId?: string;
    itemNumber?: {
      value: string;
    };
    categories?: string[];
    discussionDisabled: boolean;
    reports?: Report[];
    tasks: CourseStep[];
  };
};

export const getCourse = (courseId: string) => {
  return cacheableRequest(`/v1/tasklists/${courseId}`)
    .then(({ data }: AxiosResponse<GetCourseResponse>) => {
      return {
        ...data.tasklist,
        id: data.tasklist._id.id,
        reports: data.tasklist.reports || [],
        tasks: data.tasklist.tasks || [],
        deliverCertificate: data.tasklist.certificateId !== undefined ? true : false,
        itemNumber: data.tasklist.itemNumber?.value,
        category: data.tasklist.categories !== undefined ? data.tasklist.categories[0] : undefined,
        discussionDisabled: data.tasklist.discussionDisabled === true,
      };
    })
    .catch((reason: AxiosError) => reason);
};
